export var Shape;
(function (Shape) {
    Shape["Square"] = "Square";
    Shape["RectangleA"] = "RectangleA";
    Shape["RectangleB"] = "RectangleB";
})(Shape || (Shape = {}));
export var TActState;
(function (TActState) {
    TActState["UnkonwnActState"] = "UnkonwnActState";
    TActState["ComingSoon"] = "ComingSoon";
    TActState["OnGoing"] = "OnGoing";
    TActState["Ended"] = "Ended";
})(TActState || (TActState = {}));
export var SessionStatus;
(function (SessionStatus) {
    SessionStatus["REMAINING"] = "Remaining";
    SessionStatus["COMING_SOON"] = "Coming Soon";
    SessionStatus["TOMORROW"] = "Tomorrow";
})(SessionStatus || (SessionStatus = {}));
export const getSettingStatus = (state) => {
    switch (state) {
        case TActState.OnGoing:
            return SessionStatus.REMAINING;
        case TActState.ComingSoon:
            return SessionStatus.COMING_SOON;
        default:
            return SessionStatus.COMING_SOON;
    }
};
export const getActiveTabIndex = ({ activeTab, tagGroup }) => {
    return Math.max(tagGroup.findIndex(tag => tag.id === activeTab), 0);
};
